module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-Light.14abd6f.woff";